<template>
  <div id="app">
    <iframe id="typeform-full" width="100%" height="107%" frameborder="0" src="https://kylefeigenbaum.typeform.com/to/fRXZOx"></iframe>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html { margin: 0; height: 100%; overflow: hidden; }
iframe { position: absolute; left:0; right:0; bottom:0; top:0; border:0; }

</style>
